import clsx from 'clsx';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  /** primary ボタンの中など、色付きの面の上に出すとき */
  inverse?: boolean;
}

const SIZE_CLASSES: Record<Required<SpinnerProps>['size'], string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-4',
};

export function Spinner({ size = 'md', inverse = false }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label="loading"
      className={clsx(
        'animate-spin rounded-full',
        inverse ? 'border-white/40 border-t-white' : 'border-border border-t-primary',
        SIZE_CLASSES[size]
      )}
    />
  );
}
